import callApi from './personnelService';

const basePath = `/frontend/api/one-to-one/${process.env.VUE_APP_COMPANY_KEY}/profile`;

export const getProfile = () => callApi({
    method: 'POST',
    endpoint: `${basePath}/get-profile`
  });
